function initAlert() {
  const a = document.createElement("div");
  a.id = "alertEl";
  a.classList.add("alert");
  a.innerHTML = `
    <div class="alert-mask"></div>
    <div class="alert-content">
      <div class="alert-icon"></div>
      <div class="alert-message"></div>
      <div class="alert-btns">
        <button class="alert-btn alert-btn-confirm">确定</button>
      </div>
    </div>
  `;
  document.body.appendChild(a);

  // 点击遮罩关闭弹窗
  // const mask = a.querySelector(".alert-mask");
  // mask.addEventListener("click", () => {
  //   hideAlert();
  // });

  // 点击确定按钮关闭弹窗
  const confirmBtn = a.querySelector(".alert-btn-confirm");
  confirmBtn.addEventListener("click", () => {
    hideAlert();
    if (window.__alert_callback__) {
      window.__alert_callback__();
    }
  });
}
initAlert();

export function showAlert(config = { message: "", type: "info", onConfirm: null }) {
  const a = document.getElementById("alertEl");
  if (!a) return;

  a.classList.add("show");

  // 设置消息内容
  const msgEl = a.querySelector(".alert-message");
  if (msgEl) {
    msgEl.innerText = typeof config === "string" ? config : config.message || "";
  }

  // 设置类型（success/error/warning/info）
  const iconEl = a.querySelector(".alert-icon");
  if (iconEl) {
    const type = typeof config === "object" ? config.type || "info" : "info";
    iconEl.className = `alert-icon alert-icon-${type}`;

    // 根据类型设置图标
    let iconHtml = "";
    switch (type) {
      case "success":
        iconHtml = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>`;
        break;
      case "error":
        iconHtml = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>`;
        break;
      case "warning":
        iconHtml = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><circle cx="12" cy="16" r="0.5" fill="currentColor"/></svg>`;
        break;
      default:
        iconHtml = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><circle cx="12" cy="8" r="0.5" fill="currentColor"/></svg>`;
    }
    iconEl.innerHTML = iconHtml;
  }

  // 设置回调函数
  if (typeof config === "object" && config.onConfirm) {
    window.__alert_callback__ = config.onConfirm;
  } else {
    window.__alert_callback__ = null;
  }

  // 自动关闭（可选）
  if (typeof config === "object" && config.timeout > 0) {
    clearTimeout(window.__alert_timeout__);
    window.__alert_timeout__ = setTimeout(() => {
      hideAlert();
    }, config.timeout);
  }
}

export function hideAlert() {
  const a = document.getElementById("alertEl");
  if (a) {
    a.classList.remove("show");
  }
}

// 便捷方法
export function alertSuccess(message, onConfirm) {
  showAlert({ message, type: "success", onConfirm });
}

export function alertError(message, onConfirm) {
  showAlert({ message, type: "error", onConfirm });
}

export function alertWarning(message, onConfirm) {
  showAlert({ message, type: "warning", onConfirm });
}

export function alertInfo(message, onConfirm) {
  showAlert({ message, type: "info", onConfirm });
}

export default {
  show: showAlert,
  hide: hideAlert,
  success: alertSuccess,
  error: alertError,
  warning: alertWarning,
  info: alertInfo,
};
